import { getDefaultFleetParamBase, IFleetParamBase } from './IFleetParamBase'

export interface IFleetParamFormation extends IFleetParamBase {
  ratio_ellipse: number //0 ou 1
  rotation: number //En degre -180 - 180
  distance: number //En kilometre
}

export function getDefaultFleetParamSimulation({
  missionIds = [],
  missionHisto = [],
  freeMissionIds = [],
  associationIds = [],
  start_date = null,
  end_date = null,
  manager = '',
  phone = '',
  argos = {},
  ratio_ellipse = 1,
  rotation = 0,
  distance = 0.5,
}): IFleetParamFormation {
  return {
    ...getDefaultFleetParamBase({
      missionIds,
      missionHisto,
      associationIds,
      freeMissionIds,
      start_date,
      end_date,
      manager,
      phone,
      argos,
    }),
    ratio_ellipse,
    rotation,
    distance,
  }
}

//retourne une liste de code d'erreur si la configuration n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForFleetFormation(data: IFleetParamFormation | null): Array<string> {
  const errorCode = [] as Array<string>
  //if((data?.mission_start_date ?? '') == "") errorCode.push("MissingStartDate")
  // if(!data?.mission_plan?.steps?.length) simuErrorCode.push("MissingSteps")
  // if(!((data?.mission_plan?.cur_step ?? -1) > -1)) simuErrorCode.push("MissingCurrentStep")
  // else if(data?.mission_plan.steps.findIndex(s => s.id == data?.mission_plan?.cur_step) == -1) simuErrorCode.push("MissingCurrentStep")
  // if(data?.mission_plan?.steps?.some(s => !((s?.prfNav_id ?? -1) > -1))) simuErrorCode.push("MissingProfilNavOnStep")
  // if(data?.mission_plan?.payload?.length && data?.mission_plan?.steps?.some(s => s?.payload_enable && !((s?.prfSci_id ?? -1) > -1))) simuErrorCode.push("MissingProfilSciOnStep")
  return errorCode
}
